import React, { useState } from 'react';
import VideoTutorialModal from './VideoTutorialModal';

const ZaloSupportModal = ({ isOpen, onClose, t, support }) => {
  if (!isOpen) return null;

  const hasProSubscription = support?.hasProSubscription;
  const zaloPhoneNumber = support?.zaloPhoneNumber;
  const zaloUrl = `https://zalo.me/${zaloPhoneNumber}`;

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      onClick={onClose}
      data-testid="zalo-support-modal"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t('dashboard.index.need_help.zalo_support')}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label={t('common.close')}
            ></button>
          </div>
          <div className="modal-body text-center">
            {hasProSubscription ? (
              <>
                <p className="mb-4">{t('dashboard.index.need_help.zalo_support_available')}</p>
                <a
                  href={zaloUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                  data-testid="zalo-contact-button"
                >
                  <i className="bi bi-chat-dots me-2"></i>
                  {t('dashboard.index.need_help.contact_zalo_support')}
                </a>
              </>
            ) : (
              <p className="text-muted mb-0">
                {t('dashboard.index.need_help.zalo_support_pro_only')}
              </p>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              {t('common.close')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const NeedHelp = ({ t, support, livechatEnabled = false }) => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [isZaloModalOpen, setIsZaloModalOpen] = useState(false);

  const handleVideoTutorialsClick = (e) => {
    e.preventDefault();
    setIsVideoModalOpen(true);
  };

  const handleContactSupportClick = (e) => {
    e.preventDefault();
    if (window.LiveChatWidget) {
      window.LiveChatWidget.call('maximize');
    }
  };

  const handleZaloSupportClick = (e) => {
    e.preventDefault();
    setIsZaloModalOpen(true);
  };

  return (
    <div className="card border rounded-3 mt-4">
      <div className="card-body p-4">
        <h3 className="h6 fw-bold mb-4">{t('dashboard.index.need_help.title')}</h3>
        <div className="d-flex flex-column gap-3">
          {livechatEnabled && (
            <a
              href="#"
              className="text-decoration-none text-muted d-flex align-items-center"
              onClick={handleContactSupportClick}
              data-testid="contact-support-link"
            >
              <i className="bi bi-headset me-2"></i>
              <span>{t('dashboard.index.need_help.contact_support')}</span>
            </a>
          )}
          <a
            href="#"
            className="text-decoration-none text-muted d-flex align-items-center"
            onClick={handleVideoTutorialsClick}
            data-testid="video-tutorials-link"
          >
            <i className="bi bi-play-circle me-2"></i>
            <span>{t('dashboard.index.need_help.video_tutorials')}</span>
          </a>
          <a
            href="#"
            className="text-decoration-none text-muted d-flex align-items-center"
            onClick={handleZaloSupportClick}
            data-testid="zalo-support-link"
          >
            <i className="bi bi-chat-dots me-2"></i>
            <span>{t('dashboard.index.need_help.zalo_support')}</span>
          </a>
        </div>
      </div>
      <VideoTutorialModal
        isOpen={isVideoModalOpen}
        onClose={() => setIsVideoModalOpen(false)}
        t={t}
      />
      <ZaloSupportModal
        isOpen={isZaloModalOpen}
        onClose={() => setIsZaloModalOpen(false)}
        t={t}
        support={support}
      />
    </div>
  );
};

export default NeedHelp;
